module.exports = __webpack_public_path__ + "static/media/Axolotl 4 Life.f286ef2f.ogg";